module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/03-f23123c010dc5bd5f9e60dc496b1f3a1.jpg";